/* Shrine-Style DTC — minimal behaviour layer (no dependencies, deferred) */
(function () {
  'use strict';

  /* ---- Sticky header shadow ------------------------------------------ */
  var header = document.querySelector('[data-sticky-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 4);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Mobile nav drawer ---------------------------------------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-drawer-toggle]');
    if (!toggle) return;
    var drawer = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!drawer) return;
    var open = drawer.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  });

  /* ---- Evergreen countdown (72h, persisted per visitor) --------------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var hours = parseInt(el.getAttribute('data-countdown'), 10) || 72;
    var key = 'shrine-countdown-' + hours;
    var end;
    try {
      end = parseInt(localStorage.getItem(key), 10);
      if (!end || end < Date.now()) {
        end = Date.now() + hours * 3600 * 1000;
        localStorage.setItem(key, String(end));
      }
    } catch (err) {
      end = Date.now() + hours * 3600 * 1000;
    }
    var tick = function () {
      var d = Math.max(0, end - Date.now());
      var h = Math.floor(d / 3600000);
      var m = Math.floor((d % 3600000) / 60000);
      var s = Math.floor((d % 60000) / 1000);
      el.textContent =
        String(h).padStart(2, '0') + ':' +
        String(m).padStart(2, '0') + ':' +
        String(s).padStart(2, '0');
    };
    tick();
    setInterval(tick, 1000);
  });

  /* ---- Announcement rotator -------------------------------------------- */
  document.querySelectorAll('[data-announcement-rotator]').forEach(function (bar) {
    var items = bar.querySelectorAll('[data-announcement-item]');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].hidden = true;
      i = (i + 1) % items.length;
      items[i].hidden = false;
    }, 4000);
  });

  /* ---- Testimonial carousel -------------------------------------------- */
  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var step = function () {
      var card = track.querySelector(':scope > *');
      return card ? card.getBoundingClientRect().width + 20 : 320;
    };
    root.querySelectorAll('[data-carousel-prev]').forEach(function (b) {
      b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    });
    root.querySelectorAll('[data-carousel-next]').forEach(function (b) {
      b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
    var auto = root.getAttribute('data-carousel-auto') === 'true';
    if (auto && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var timer = setInterval(function () {
        var max = track.scrollWidth - track.clientWidth - 4;
        if (track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: step(), behavior: 'smooth' });
      }, 5000);
      root.addEventListener('pointerenter', function () { clearInterval(timer); }, { once: true });
    }
  });

  /* ---- FAQ: optional one-open-at-a-time --------------------------------- */
  document.querySelectorAll('[data-faq-single="true"]').forEach(function (group) {
    group.addEventListener('toggle', function (e) {
      if (!e.target.open) return;
      group.querySelectorAll('details[open]').forEach(function (d) {
        if (d !== e.target) d.open = false;
      });
    }, true);
  });

  /* ---- Reveal on scroll --------------------------------------------------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
  }
})();
